module.exports = __webpack_public_path__ + "static/img/clothing_12.3122213.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/large/clothing_12.png
// module id = z9SB
// module chunks = 0